export default __webpack_public_path__ + "static/media/UnfilledStar.aa2a9b3b.svg";